const HAT_CATEGORIES = ["hat", "cap", "hat.casual", "hat.beanie", "hat.other"];

/**
 * lowercase the category string of the product and evaluates
 * if that string is a hat category
 */
export const isPriorityCategory = (category) => {
  const lowerCaseCategory = category?.toLowerCase();

  return HAT_CATEGORIES.some((hatCategory) =>
    lowerCaseCategory?.includes(hatCategory)
  );
};

/**
 * Re orders the products base on the current category
 * and put in the first place the ones that are bellow to
 * "hats" or "head"
 */
export const reorderHatsProductsByCategory = (products = []) => {
  const priorityProducts = [];
  const otherProducts = [];

  products.forEach((product) => {
    if (isPriorityCategory(product?.category)) {
      priorityProducts.push(product);
    } else {
      otherProducts.push(product);
    }
  });

  return [...priorityProducts, ...otherProducts];
};
